import { useTranslation } from "react-i18next";

const Features = () => {
  const { t } = useTranslation(["marketing", "common"]);
  const items = t("features.items", { returnObjects: true }) as {
    title: string;
    description: string;
  }[];

  return (
    <div data-testid="page-features" className="mx-auto max-w-4xl px-4 py-16">
      <h1 className="font-display text-3xl font-black">{t("features.title")}</h1>
      <p className="mt-4 text-ink-soft">{t("features.intro")}</p>

      <ul className="mt-10 grid gap-6 sm:grid-cols-2">
        {items.map((item) => (
          <li key={item.title} className="card p-6">
            <h2 className="font-display font-extrabold">{item.title}</h2>
            <p className="mt-2 text-sm text-ink-soft">{item.description}</p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Features;
